import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { isGearedOrGearless } from './dashboard-jetty.helper'
import { DashboardJettyAPI } from '../../../api'

const useHooks = (props) => {
  const [selectedItem, setSelectedItem] = useState()
  const [availableJetty, setAvailableJetty] = useState([])
  const [showModalTOJ, setShowModalTOJ] = useState(false)
  const [isShowWarningInfo, setIsShowWarningInfo] = useState(false)

  const appSize = useSelector((state) => state.appReducer)
  const scaleFactor =
    (parseInt(appSize.height) - (110 * parseInt(appSize.height)) / 943) / 943

  const toggleModalTOJ = () => setShowModalTOJ((prev) => !prev)
  const toggleWarningInfo = () => setIsShowWarningInfo((prev) => !prev)

  const hadleClickItem = (item) => {
    setSelectedItem(item)
    toggleModalTOJ()
  }

  const handleUpdateEquipment = async (index, type) => {
    try {
      let updatedData = []
      const data = props.dataJetty[index]?.Report

      if (type === 'crane') {
        const cranes = (data.Crane_Maps || []).slice(0, 2).map((crane) => ({
          code: crane.Task_Detail_Code,
          position: crane.Position.toLowerCase() === 'left' ? 'right' : 'left'
        }))
        updatedData = cranes
      } else if (type === 'barge') {
        const barges = (data.Barge_Maps || []).slice(0, 2).map((barge) => ({
          code: barge.Task_Detail_Code,
          position: barge.Position.toLowerCase() === 'left' ? 'right' : 'left'
        }))
        updatedData = barges
      } else {
        return
      }

      const response = await DashboardJettyAPI.UpdateCraneBargePosition(
        updatedData
      )
      if (response?.status !== 200)
        throw new Error(response?.error || response?.message?.error)
      props.refetchJettyMaps()
    } catch (error) {
      console.error('Error updating position:', error)
    }
  }

  const reconstructDataJetty = () => {
    const available = (props.dataJetty || []).map((dt, i) => {
      const isCorrectVesselType = isGearedOrGearless(dt?.Report?.Vessel_Size)
      let percent = 0
      if (dt?.Report?.Stowage_Plan === 0 && dt?.Report?.Actual > 0) {
        percent = 100
      } else if (dt?.Report?.Actual && dt?.Report?.Stowage_Plan) {
        percent = Math.round((dt.Report.Actual / dt.Report.Stowage_Plan) * 100)
        percent = percent > 100 ? 100 : percent
      }

      const reportTable = dt?.Report?.Vessel_Name
        ? {
            ...dt.Report,
            Percentage: percent
          }
        : null
      const reportMaps =
        dt?.Report?.Vessel_Name && isCorrectVesselType
          ? {
              ...dt.Report,
              Percentage: percent
            }
          : null
      return {
        position: i,
        show: !!reportMaps,
        detail: reportMaps,
        detailTable: reportTable,
        jettyLength: dt?.Length
      }
    })
    setAvailableJetty(available)
  }

  useEffect(() => {
    reconstructDataJetty()
  }, [props.dataJetty])

  return {
    data: {
      appSize,
      scaleFactor,
      showModalTOJ,
      selectedItem,
      availableJetty,
      isShowWarningInfo
    },
    methods: {
      toggleModalTOJ,
      hadleClickItem,
      setAvailableJetty,
      toggleWarningInfo,
      handleUpdateEquipment
    }
  }
}

export default useHooks
